<template>
  <PageWrapper>
    <HeaderBlock />
    <PageTop v-if="content" :content="content" />
    <PageContent v-if="content?.name" :content="content" />
    <FooterBlock />
    <Transition>
      <PageCardModal
        v-if="store.showModal"
        @handle-close-preview="handleClosePreview"
      />
    </Transition>
  </PageWrapper>
</template>
<script setup lang="ts">
import { getNominationBySlug } from "~/backend/composables/base"
import { useNominationPageStore } from "~/store/nominationPage"
const store = useNominationPageStore()
const route = useRoute()
const router = useRouter()
const slug = String(route.params.slug)
const content = await getNominationBySlug(slug)
const handleClosePreview = async () => {
  store.handleClosePreview()

  if (!import.meta.client || !route.hash) return

  const currentScrollX = window.scrollX
  const currentScrollY = window.scrollY
  await router.replace({ hash: "" })
  window.scrollTo({ left: currentScrollX, top: currentScrollY, behavior: "auto" })
}

const seo = content.value?.seo

useSeoMeta({
  title: seo?.metaTitle || content.value?.name,
  ogTitle: seo?.metaTitle || content.value?.name,
  description: seo?.metaDescription || content.value?.description,
  ogDescription: seo?.metaDescription || content.value?.description,
  keywords: seo?.keywords,
  robots: seo?.metaRobots,
  ogImageUrl:
    useStrapiMediaUrl(seo?.metaImage?.data?.attributes?.url),
})
</script>
<style lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
